'use client';
import { storyblokInit, useStoryblokBridge as withStoryblokBridge, } from '@storyblok/js';
import { useEffect, useLayoutEffect, useState } from 'react';
storyblokInit({ accessToken: 'secret' });
export const StoryblokPreview = ({ defaultRender, bridgeConfig, renderAction, context, }) => {
    const [render, setRender] = useState(defaultRender);
    const [initialStory, setInitialStory] = useState(context.story);
    useEffect(() => {
        (async () => {
            const preview = await renderAction({ ...context, story: initialStory });
            setRender(preview);
        })();
    }, [context, initialStory, renderAction]);
    useLayoutEffect(() => {
        withStoryblokBridge(context.story.id, setInitialStory, bridgeConfig);
    }, [bridgeConfig, context.story, setInitialStory]);
    return render;
};
